module.exports = __webpack_public_path__ + "fromBrideToMother-we-g.b51ee86d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToMother-we-g.jpg
// module id = 3FYB
// module chunks = 0